import recommend from "@algolia/recommend";
import algoliasearch from "algoliasearch";

const appId = process.env.REACT_APP_ALGOLIA_APP_ID;

if (!appId) {
  throw new Error("Missing environment variable REACT_APP_ALGOLIA_APP_ID");
}

const apiKey = process.env.REACT_APP_ALGOLIA_API_KEY;

if (!apiKey) {
  throw new Error("Missing environment variable REACT_APP_ALGOLIA_API_KEY");
}

const productsPrefix = "shopify_products";

export const defaultIndex = [
  process.env.REACT_APP_ALGOLIA_PREFIX,
  productsPrefix,
].join("_");

export const recommendClient = recommend(appId, apiKey);
export const searchClient = algoliasearch(appId, apiKey);
